import React from 'react';

interface InputProps {
  type?: 'text' | 'email' | 'password' | 'tel';
  id?: string;
  name?: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  id,
  name,
  value,
  placeholder,
  required = false,
  disabled = false,
  onChange,
  className = '',
  label
}) => {
  const baseClasses = 'w-full px-4 py-3 border border-cream-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent transition-colors';

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={id} className="block text-sm font-semibold text-brown-800">
          {label} {required && '*'}
        </label>
      )}
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        onChange={onChange}
        className={`${baseClasses} ${className}`}
        style={{ outline: 'none' }}
      />
    </div>
  );
};

export default Input;